import Model from './Model'

export default class BudgetModel extends Model {
  public id: number|undefined

  resource () : string {
    return 'budgets'
  }
}
